// 6px dot + mono label. Used across DeckDetail, PlaytestJob, and any place
// where a status badge would otherwise be a colored pill. The dot carries
// tone; the label stays in text-color. Reads as a system, not a decoration.

import { cn } from "../lib/cn";

export type Status = "ready" | "active" | "draft" | "error" | "success";

interface Props {
  status: Status;
  label?: string;
  className?: string;
}

const TONE: Record<Status, string> = {
  ready: "bg-success",
  active: "bg-accent",
  draft: "bg-border-strong",
  error: "bg-danger",
  success: "bg-success",
};

const DEFAULT_LABEL: Record<Status, string> = {
  ready: "Ready",
  active: "Active",
  draft: "Draft",
  error: "Error",
  success: "Complete",
};

export default function StatusDot({ status, label, className }: Props) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 align-middle",
        className,
      )}
    >
      <span
        aria-hidden
        className={cn("h-[6px] w-[6px] rounded-full", TONE[status])}
      />
      <span className="font-mono text-[10px] uppercase tracking-widest text-fg-muted">
        {label ?? DEFAULT_LABEL[status]}
      </span>
    </span>
  );
}
